import React from "react"
import SpotifyLogo from "./spotify-logo"

const ellipsis = (string, count) => {
  if (string && string.length <= count) {
    return string
  }
  return `${string.slice(0, count).trim()}...`
}

const Header = ({ attributes, title }) => {
  return (
    <table
      {...attributes}
      style={{ width: "100%", borderCollapse: "collapse", padding: 0 }}
    >
      <tbody>
        <tr>
          <td style={{ padding: 0 }}>
            <div
              {...attributes}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                color: "white",
                paddingTop: "6px",
                paddingBottom: "0px",
                fontFamily: "system-ui"
              }}
            >
              {ellipsis(title, 22)}
              <SpotifyLogo />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Header
